<template>
  <fieldset>
    <h3
      class="otb-interactive-tag-group__label wb-type-label"
      v-if="icon || label"
    >
      <wb-icon
        v-if="icon"
        class="otb-interactive-tag-group__icon"
        :name="icon"
      ></wb-icon>
      <span class="otb-interactive-tag-group__text">{{ label }}</span>
    </h3>
    <interactive-tag
      v-for="(option, index) in options"
      class="otb-interactive-tag-group__option"
      :checked="isChecked(option.value)"
      :disabled="option.disabled"
      :key="`${option.name}-${index}`"
      :name="name"
      :value="option.value"
      :variant="'radio'"
      @change="inputChange"
    >
      {{ option.text }}
    </interactive-tag>
  </fieldset>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue';

import { InteractiveTag } from '../index';

export default defineComponent({
  name: 'otb-interactive-tag-group',
  components: {
    InteractiveTag,
  },
  props: {
    icon: String,
    label: String,
    name: String,
    options: Array,
    selectedValue: String,
  },
  setup(props, { emit }) {
    const selectedValue = ref('');
    const isChecked = (value: string): boolean => {
      return selectedValue.value === value;
    };

    const inputChange = ({ value }: { value: string }): void => {
      selectedValue.value = value;
      emit('change', {
        name: props.name,
        value: selectedValue.value,
      });
    };
    watch(
      () => props.selectedValue,
      (newValue) => {
        if (newValue) {
          selectedValue.value = newValue;
        }
      }
    );
    onMounted((): void => {
      if (props.selectedValue) {
        selectedValue.value = props.selectedValue;
      }
    });

    return {
      isChecked,
      inputChange,
    };
  },
});
</script>
<style lang="scss" src="./interactive-tag-group.scss"></style>
